import React from 'react';
import dynamic from 'next/dynamic';
import { Flex } from '@acko-tech/building-blocks.ui.common';
import Fuse from 'fuse.js';
import { FuelOptionsText, FuelTextContainer, StyledBox } from './styles';
import { useResponsiveDevice } from 'hooks/useResponsiveDevice';

const InputSearch = dynamic(() => import('../onInputFilter'), {
    ssr: true,
});

export default function MmvOptions({
    queryType,
    popularVehicles,
    fuelType,
    variantType,
    vehicles,
    handleClick,
    vehicleType,
}: ComponentProps): JSX.Element {
    const handleSelect = (option: HandleClickParamTypes) => handleClick(option);
    const { isMobile } = useResponsiveDevice();
    const isDesktop = !isMobile;
    const fuseOptions = {
        keys: ['name'],
    };
    switch (queryType) {
        case 'make': {
            const fuseMake = new Fuse(vehicles, fuseOptions);
            return (
                <InputSearch
                    defaultOptions={popularVehicles}
                    // totalOptions={vehicles}
                    handleSelect={(value, searchText) =>
                        handleSelect({ value, type: 'make', searchText })
                    }
                    placeHolder="Search your car"
                    defaultHeading="Top Search Results"
                    errorText="We couldn't find this car. Try searching for another one, or check for typing errors."
                    fuseObject={fuseMake}
                    showMobileType={!isDesktop}
                    displaySearchItems={60}
                    searchCallback={() => {}}
                    showCrossIcon={true}
                    pb={true}
                />
            );
        }
        case 'model':
            return (
                <Flex justifyContent="center" flexDirection="column">
                    <StyledBox>
                        {fuelType.map((item) => {
                            return (
                                <FuelTextContainer
                                    key={item.name}
                                    onClick={() => {
                                        handleSelect({
                                            value: item,
                                            type: 'model',
                                        });
                                    }}
                                >
                                    <FuelOptionsText>
                                        {item.name}
                                    </FuelOptionsText>
                                </FuelTextContainer>
                            );
                        })}
                    </StyledBox>
                </Flex>
            );
        case 'variant': {
            const fuseVariant = new Fuse(variantType, fuseOptions);
            return (
                <InputSearch
                    defaultOptions={variantType}
                    // totalOptions={variantType}
                    handleSelect={(value, searchText) => {
                        handleSelect({ value, type: 'variant', searchText });
                    }}
                    placeHolder={`Select your car's variant type`}
                    errorText="We couldn't find this variant. Try searching for another one, or check for typing errors."
                    // checkpoint="variant"
                    fuseObject={fuseVariant}
                    showMobileType={!isDesktop}
                    displaySearchItems={60}
                    searchCallback={() => {}}
                    showSeatingCapacity={vehicleType === 'pcv'}
                    showGrossVehicleWeight={vehicleType === 'gcv'}
                    showCrossIcon={true}
                    pb={true}
                />
            );
        }
        default:
            return <> </>;
    }
}

interface ComponentProps {
    queryType: string;
    vehicles: VehicleProps[];
    popularVehicles: VehicleProps[];
    variantType: VariantProps[];
    fuelType: FuelProps[];
    handleClick({ value, type, searchText }: HandleClickParamTypes): void;
    vehicleType?: string;
}

interface HandleClickParamTypes {
    value: any;
    type: string;
    searchText?: string;
}

interface VehicleProps {
    id: number;
    name: string;
    logo: string;
}

interface VariantProps {
    name: string;
}
interface FuelProps {
    name: string;
    key: string;
}
